import { jsx as _jsx } from "react/jsx-runtime";
import hljs from "highlight.js";
import { useMemo } from "react";
import ReactQuill from "react-quill";
import { useDeviceType } from "../../hooks/useDeviceType.js";
import { EDeviceType } from "../../types/device/device.js";
/**
 * Wrapper for Quill Editor (WYSIWYG).
 * Implemented to be compatible with AntD Forms.
 */ const QuillEditorWrapper = ({ value, className, isSmallToolbarMenu, hiddenToolbar = false, ...restProps })=>{
    // default formats
    const formats = useMemo(()=>{
        return [
            // inline
            "bold",
            "italic",
            "underline",
            "strike",
            "link",
            "code",
            // blocks
            "blockquote",
            "code-block",
            // lists
            "list",
            "bullet"
        ];
    }, []);
    const deviceType = useDeviceType();
    /**
     * Do not handle deviceType in memo, as this will cause rerendering and focus issues on quill editor
     * @see https://github.com/zenoamaro/react-quill/issues/317
     * */ const modules = useMemo(()=>{
        let toolbar = undefined;
        if (hiddenToolbar !== true) {
            const isBigScreenDevice = isSmallToolbarMenu === undefined && deviceType === EDeviceType.DESKTOP || !isSmallToolbarMenu;
            // build dynamic toolbar menu entries
            const dynamicMenuEntries = isBigScreenDevice ? [
                [
                    "blockquote",
                    "code-block"
                ],
                // ["custom-format"],
                [
                    {
                        list: "ordered"
                    },
                    {
                        list: "bullet"
                    }
                ]
            ] : [];
            const defaultMenu = [
                "bold",
                "italic",
                "underline",
                "code"
            ];
            if (isBigScreenDevice) {
                defaultMenu.push("strike");
            }
            toolbar = {
                container: [
                    defaultMenu,
                    ...dynamicMenuEntries,
                    [
                        "link"
                    ],
                    [
                        "clean"
                    ]
                ],
                history: {
                    delay: 500,
                    maxStack: 250,
                    userOnly: true
                }
            };
        }
        return {
            syntax: {
                highlight: (text)=>hljs.highlightAuto(text).value
            },
            toolbar: toolbar ? toolbar : false
        };
    }, [
        isSmallToolbarMenu,
        hiddenToolbar
    ]);
    const autoClassName = `${process.env.ANTD_PREFIX}-quill-wrapper${restProps?.readOnly ? "-disabled" : ""}`;
    return /*#__PURE__*/ _jsx(ReactQuill, {
        className: [
            className,
            autoClassName
        ].filter(Boolean).join(" "),
        theme: "snow",
        value: value || "",
        modules: modules,
        formats: formats,
        ...restProps
    });
};
export { QuillEditorWrapper };
